import React, { useEffect } from "react";
import { useRouter } from "next/router";
import { SucessGreenTick } from "../../constants/icons";
import { REDIRECT_DELAY } from "../../constants/variables";
import { useAuth } from "../../context/AuthContext";

function SuccessAuth({ message, handleOpen }) {
  const router = useRouter();
  const [transition, setTransiton] = React.useState(false);
  const { currentAuthUser, user } = useAuth();

  useEffect(() => {
    setTimeout(() => {
      setTransiton(true);
    }, 1000);

    setTimeout(() => {
      handleOpen(false);
      const eventFire = true; // this is for the event to fire only whenuser is login
      currentAuthUser(eventFire);
      // event for the user auth
      // router.push("/");
    }, REDIRECT_DELAY);
  }, []);

  // ? returns sign in module's OTP screen
  return (
    <div className="w-80 m-auto h-full flex flex-col justify-between">
      <div className={`relative transition-all duration-1000 ${transition ? "top-40 opacity-1" : "top-60 opacity-0"}`}>
        <div className="flex justify-center text-typography-success">
          <SucessGreenTick fill="inherit"/>
        </div>
        <p className="text-typography-success my-4 text-xl text-center font-semibold">{message}</p>
      </div>
    </div>
  );
}

export default SuccessAuth;
